;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import type { JwtPayload } from '../types/auth';
import { ACCESSIBLE_APPS, CONTRACTOR_ROLE_VALUES, TEAM_ROLE_IDS, USER_ROLES } from './constants';

/** Employee seat with team lead / global admin (and related roles): My / Team LHS submenu. */
export function getShowPersonalTeamNavSubmenu(params: {
  isEmployer: boolean;
  isContractorViewer: boolean;
  isTeamsGlobalAdmin: boolean;
  hasTeamLeadOrAdminOnTeam: boolean;
}): boolean {
  const { isEmployer, isContractorViewer, isTeamsGlobalAdmin, hasTeamLeadOrAdminOnTeam } = params;

  return !isContractorViewer && (isTeamsGlobalAdmin || (!isEmployer && hasTeamLeadOrAdminOnTeam));
}

/** @deprecated Use {@link getShowPersonalTeamNavSubmenu}. */
export const getShowAbsenceNavSubmenu = getShowPersonalTeamNavSubmenu;

/** Expenses LHS: My expenses / Team expenses (same eligibility as absences). */
export const getShowExpenseNavSubmenu = getShowPersonalTeamNavSubmenu;

/** Payroll LHS: My monthly inputs / Team monthly inputs (same eligibility as absences). */
export const getShowMonthlyInputsNavSubmenu = getShowPersonalTeamNavSubmenu;

/** Server-side equivalent of the sidebar My / Team submenu check, derived from the decoded JWT. */
export function getShowPersonalTeamNavSubmenuFromToken(decodedToken: JwtPayload): boolean {
  const roles = decodedToken.roles ?? [];
  const teams = decodedToken.teams ?? [];
  const isContractorJwt =
    decodedToken.accessible_app === ACCESSIBLE_APPS.CONTRACTOR ||
    CONTRACTOR_ROLE_VALUES.some((role) => roles.includes(role));
  const isTeamsGlobalAdmin = roles.includes(USER_ROLES.TEAMS_GLOBAL_ADMIN);
  const hasTeamLead = teams.some((team) =>
    (team.team_role ?? []).includes(TEAM_ROLE_IDS.TEAM_LEAD)
  );
  const hasTeamLeadOrAdminOnTeam =
    hasTeamLead ||
    teams.some((team) => (team.team_role ?? []).includes(TEAM_ROLE_IDS.GLOBAL_ADMIN));

  return getShowPersonalTeamNavSubmenu({
    isEmployer: decodedToken.accessible_app === ACCESSIBLE_APPS.EMPLOYER,
    isContractorViewer: isContractorJwt && (isTeamsGlobalAdmin || hasTeamLead),
    isTeamsGlobalAdmin,
    hasTeamLeadOrAdminOnTeam,
  });
}
